import React, { useEffect, useState } from "react";
import { get } from "./common";
import { ReadinessPanel } from "@/components/gshop/ReadinessPanel";

export function ListingReadiness({ id, version, onEdit }) {
  const [d, setD] = useState(null);
  useEffect(() => { get(`/gshop-readiness/listing/${id}`).then(setD).catch(() => setD({ variants: [] })); }, [id, version]);
  if (!d) return <p className="text-sm text-slate-400">Checking…</p>;
  return (
    <div className="space-y-4" data-testid="pim-readiness">
      {d.variants.map((v) => (
        <div key={v.variant_id} className="space-y-1">
          {d.variants.length > 1 && <div className="text-xs font-semibold">{v.label} ({v.sku})</div>}
          <ReadinessPanel d={v} onEdit={onEdit} tid={v.sku || v.variant_id} />
        </div>))}
      {!d.variants.length && <p className="text-sm text-slate-500">Add a variant to check Google readiness.</p>}
    </div>
  );
}
